(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hx-customers-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-hx-chips]').forEach(function (bar) {
    var grid = bar.parentElement && bar.parentElement.querySelector('.rgrid');
    if (!grid) return;
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-chip]');
      if (!b) return;
      Array.prototype.forEach.call(bar.querySelectorAll('[data-chip]'), function (x) { x.classList.toggle('on', x === b); });
      var q = (b.getAttribute('data-chip') || '').toLowerCase();
      Array.prototype.forEach.call(grid.querySelectorAll('.rc'), function (c) {
        c.hidden = !!q && (c.getAttribute('data-key') || '').indexOf(q) === -1;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hx-doctors-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var blocks = Array.prototype.slice.call(document.querySelectorAll('.dpage .dprod[data-src]'));
  if (!blocks.length) return;
  window.__hxFrModal = window.__hxFrModal || {};
  function load(block) {
    if (block.dataset.loaded) return;
    block.dataset.loaded = '1';
    var id = block.dataset.frId, src = block.dataset.src;
    if (!window.__hxFrModal[id]) {
      window.__hxFrModal[id] = fetch(src)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }
    window.__hxFrModal[id].then(function (doc) {
      // live count from the "N clinicians are including this product" sentence
      var n = 0, answers = doc.querySelectorAll('.fr-question-answer');
      for (var i = 0; i < answers.length && !n; i++) {
        var m = /(\d[\d,]*)\s+clinicians/i.exec(answers[i].textContent || '');
        if (m) n = parseInt(m[1].replace(/,/g, ''), 10) || 0;
      }
      var countEl = block.querySelector('[data-fr-count]');
      if (n > 0 && countEl) countEl.textContent = n.toLocaleString('en-AU');
      // clinician cards
      var grid = block.querySelector('[data-fr-grid]');
      var limit = parseInt(block.dataset.limit || '6', 10) || 6, added = 0;
      doc.querySelectorAll('.fr-provider-list-item [data-name]').forEach(function (el) {
        if (added >= limit || !el.dataset.name) return;
        var card = document.createElement('div'); card.className = 'dcard';
        var ph = document.createElement('span'); ph.className = 'dph';
        var imgUrl = (el.dataset.images || '').split(',')[0].trim();
        if (imgUrl) { var img = document.createElement('img'); img.src = imgUrl; img.alt = el.dataset.name; img.loading = 'lazy'; ph.appendChild(img); }
        else ph.textContent = 'Dr';
        var nm = document.createElement('span'); nm.className = 'dnm';
        var b = document.createElement('b'); b.textContent = el.dataset.name;
        var small = document.createElement('small'); small.textContent = [el.dataset.specialty, el.dataset.location].filter(Boolean).join(' · ');
        nm.appendChild(b); nm.appendChild(small); card.appendChild(ph); card.appendChild(nm); grid.appendChild(card); added++;
      });
      if (added > 0) grid.hidden = false;
    }).catch(function () { /* leave the placeholder count and no grid */ });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { load(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '300px 0px' });
    blocks.forEach(function (b) { io.observe(b); });
  } else { blocks.forEach(load); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hx-listicle-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  var body = document.querySelector('[data-listicle-body]');
  var toc = document.querySelector('[data-listicle-toc]');
  if (!body) return;
  // guarantee anchor ids on the item headings only: the Nth h2 gets the Nth
  // TOC anchor while TOC entries remain; later h2s (e.g. the conclusion) stay
  // plain headings and never pick up an item number
  var links = toc ? Array.prototype.slice.call(toc.querySelectorAll('a')) : [];
  var h2s = Array.prototype.slice.call(body.querySelectorAll('h2'));
  h2s.forEach(function (h, i) {
    if (!h.id && i < links.length) {
      var fromToc = links[i].getAttribute('href');
      h.id = fromToc ? fromToc.slice(1) : 'item-' + (i + 1);
    }
  });
  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });
  var copy = document.querySelector('[data-copy-link]');
  if (copy) copy.addEventListener('click', function () {
    try { navigator.clipboard.writeText(location.href); copy.textContent = 'Link copied'; } catch (e) { /* no-op */ }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hx-main-collection"] && !Shopify.designMode) return;
  try {
    
  // The search page's tabs: one group shows at a time
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-stab]');
    if (!tab) return;
    document.querySelectorAll('[data-stab]').forEach(function (b) { b.classList.toggle('on', b === tab); });
    document.querySelectorAll('[data-sgroup]').forEach(function (g) { g.hidden = g.dataset.sgroup !== tab.dataset.stab; });
  });
  // The sort control is a plain <select>: reload the collection with sort_by
  // set, which is what Shopify reads. Delegated so it survives a re-render.
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  } catch(e) { console.error(e); }
})();
})();
